import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageAssetsList = Loadable(lazy(() => import("./ManageAssetsList")));
const ManageAssetsEdit = Loadable(lazy(() => import("./ManageAssetsEdit")));

const ManageAssetsRoutes = [
  { path: "/assets/manage-assets", element: <ManageAssetsList /> },
  { path: "/assets/manage-assets/:mode/:id", element: <ManageAssetsEdit /> },
];

export default ManageAssetsRoutes;
